
const accessMaintenance = {

    ADD_MAINTENANCE: { name: 'Add Maintenance', path: '/add-maintenance' },
    PREVENTIVE_MAINTENANCE_LIST: { name: 'Preventive Maintenance', path: '/preventive-job-order' },
    CORRECTIVE_MAINTENANCE_LIST: { name: 'Corrective Maintenance', path: '/corrective-job-order' },
    JOB_CARD_LIST: { name: 'Job Card', path: '/job-order-list' },
    JOB_ORDER_DETAIL: { name: 'Job Order Detail', path: '/job-order-detail' },
    PREVENTIVE: { name: 'Preventive', path: '/preventive' },
    CORRECTIVE: { name: 'Corrective', path: '/corrective' },

    MAINTAINANCE_HIERARCHY: { name: 'Maintenance Hierarchy', path: '/maintenance-hierarchy' },
    STAFF_MAINTENANCE_HIERARCHY: { name: 'Staff Maintenance Hierarchy', path: '/staff-maintenance-hierarchy' },


    PLAY: { name: 'Play', path: '/play' },
    PAUSE: { name: 'Pause', path: '/pause' },
    HOLD: { name: 'Hold', path: '/hold' },
    STOP: { name: 'Stop', path: '/stop' },
    RESCHEDULE: { name: 'Reschedule', path: '/reschedule' },
    FEEDBACK: { name: 'Feedback', path: '/feedback' },


}

export default accessMaintenance;